<template>
  <div class="home">
    <!-- 首页导航 -->
    <header v-if="isHome" class="home-top" >
      <!-- 轮播图 -->
      <Carousel
        :autoplay='autoplay'
        :autoplay-speed=5000
        dots='inside'
        class="carousel"
      >
        <CarouselItem>
          <div class="item1" :style="{height: portHeight}">
            <div class="item1__title" style="position:absolute;top:25%;left:8%;">
              工程结构仿真
              <div class="item1_sub">Simulation of Engineering Structures</div>
            </div>
            <div class="item1__title2" style="position:absolute;top:38%;left:8%;">
              工程智能监测
              <div class="item1_sub">Intelligent Monitoring of Engineering</div>
            </div>
            <div class="item1__title" style="position:absolute;top:58%;left:8%;">
              工程数字科技
              <div class="item1_sub">Information Techniques of Engineering</div>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="item2" :style="{height: portHeight}">
            <div class="item2__title">Providing Professional Consulting Services</div>
            <div class="item2__title">For Structural Design, Construction, Operation And Maintenance</div>
            <div class="item2__des">为结构设计、施工、运维提供<span>专业化</span>咨询服务</div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="item3" :style="{height: portHeight}">
            <div class="item3__title">用信息化技术让结构管养更高效</div>
            <div class="item3__des">Using Information Technology</div>
            <div class="item3__des">To Make Structure Management And Maintenance More Efficient</div>
          </div>
        </CarouselItem>
        <CarouselItem v-if="hasnews">
          <div class="item2" :style="{backgroundImage: 'url('+ newsimage +')',position:'relative',paddingLeft:'0px',height: portHeight}" @click="handleLinkTo('news')">
            <div style="backdrop-filter:blur(10px);background-color:rgba(0,0,0,0.5);width: 100%;height: 100%;">
              <img :src="newsimage" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width: 80%;">
            </div>
          </div>
        </CarouselItem>
      </Carousel>
      <div class="header header--home">
        <div class="header__logo">
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/yueqiaoLogo.png"/>
          <div class="header_name">
            <span>广州粤桥工程咨询有限公司</span>
            <span>GUANGZHOU YUEQIAO ENGINEERING CONSULTING Co., LTD</span>
          </div>
        </div>
        <div class="header__nav">
          <div
            v-for="item in navList"
            :key="item.key"
            :class="selectedNav === item.key ? 'items selected' : 'items'"
          >
            <span @click="handleLinkTo(item.key)">
              {{ item.title }}
            </span>
          </div>
        </div>
      </div>
    </header>
    <!-- 其他页面导航 -->
    <header
      v-else
      class="header header--other"
    >
        <div class="header__logo">
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/yueqiaoLogo.png" />
          <div>
            <span>广州粤桥工程咨询有限公司</span>
            <span>GUANGZHOU YUEQIAO ENGINEERING CONSULTING Co., LTD</span>
          </div>
        </div>
      <div class="header__nav">
        <div
          v-for="item in navList"
          :key="item.key"
          :class="selectedNav === item.key ? 'items selected' : 'items'"
        >
          <span @click="handleLinkTo(item.key)">
            {{ item.title }}
          </span>
        </div>
      </div>
    </header>
    <router-view
      class="content"
      @changeProduce="handleLinkTo"
      @back="controlAutoplay"
    />
    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer__nav">
        <div>
          <div class="title">业务介绍</div>
          <div
            class="items"
            @click="handleSelectedProduce('struct_analyse')"
          >工程结构仿真</div>
          <div
            class="items"
            @click="handleSelectedProduce('struct_moni')"
          >工程智能监测</div>
          <div
            class="items"
            @click="handleSelectedProduce('struct_tech')"
          >工程数字科技</div>
          <!-- <div
            class="items"
            @click="handleSelectedProduce('struct_dev')"
          >工程科技研发</div> -->
        </div>
        <div>
          <div class="title">项目展示</div>
          <div
            class="items"
            @click="handleLinkTo('projectList')"
          >查看项目</div>
        </div>
        <div class="image-box">
          <div class="image">
            <img
              src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/qrcode_for_gh.jpg"
              width="100%"
              height="100%"
            />
          </div>
          <div class="title">关注粤桥工科微信公众号了解更多</div>
        </div>
        <div>
          <div class="title">友情链接</div>
          <div
            class="items"
            @click="openUrl('https://www.csijri.com/index.html')"
          >中新国际联合研究院</div>
          <div
            class="items"
            @click="openUrl('http://www.sipesc.com/')"
          >大工星派仿真科技（北京）有限公司</div>
          <!-- <div
            class="items"
            @click="openUrl('https://yueq.com.cn/bbs')"
          >校友圈</div> -->
        </div>
        <div>
          <div class="title">关于我们</div>
          <div
            class="items"
            @click="footLinkTo('about_us', 'introduce')"
          >公司简介</div>
          <div
            class="items"
            @click="footLinkTo('about_us', 'progress')"
          >发展历程</div>
          <!-- <div
            class="items"
            @click="handleLinkTo('about_us', 'productView')"
          >我们的产品观</div> -->
          <div
            class="items"
            @click="footLinkTo('about_us', 'contact')"
          >联系我们</div>
          <!--<div
            class="items"
            @click="openUrl('https://cloud.yueq.com.cn/home')"
          >工程监测</div> -->
        </div>
      </div>
      <div class="footer__des">
        <pre>公司总部：广州市天河区长福路205号C408单元  研发中心：广州市黄埔区中新智慧一街7号a-1栋1008单元  </pre>
        <!-- 联系电话：020 - xxxxxxxx -->
        <pre>
          <span>Copyright © 2020 广州粤桥工程咨询有限公司 版权所有</span>
          <!-- <div style="width:300px;margin:0 auto; padding:20px 0;">
            <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img src="" style="float:left;"/>
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44010602007527号</p >
              </a>
          </div> -->
        </pre>
        <pre>
          <span class="beian" @click="openUrl('https://beian.miit.gov.cn')">粤ICP备19155098号-2</span>
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/beian_icon.png" alt style="display:inline-block;width: 20px;height: 20px;" />
          <span class="beian" @click="openUrl('https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602011654')">粤公网安备44010602011654号</span>
          <!-- <div style="width:300px;margin:0 auto; padding:20px 0;">
            <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/beian_icon.png" style="float:left;"/>
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44010602011654号</p>
            </a>
          </div> -->
        </pre>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      headImg: '',
      isHome: false,
      selectedNav: '',
      navList: [
        { key: 'main_home', title: '首页' },
        { key: 'news', title: '最新消息' },
        { key: 'business', title: '业务介绍' },
        { key: 'projectList', title: '项目展示' },
        // { key: 'innovation', title: '科研创新' },
        { key: 'about_us', title: '关于我们' },
        // { key: 'sign', title: '登录|注册' }
      ],
      isLogin: false,
      signOutModal: false,
      produceList: ['struct_analyse', 'struct_moni', 'struct_tech'],
      autoplay: true,
      hasnews: true,
      newsimage: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/news1Image.png',
      portHeight: '100vh',
      // contentTop: 0
    }
  },
  computed: {
    isMobile(){
      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
        return true
      }
      else{
        return false
      }
    }
  },
  created () {
    if (this.$route.name === 'Home' || this.$route.name === 'main_home') {
      this.handleLinkTo('main_home')
    }
    // this.portHeight = this.isMobile?'80vh':'100vh'
    if(this.isMobile){
      // document.write('<meta name="viewport" content="width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0,user-scalable=yes,shrink-to-fit=no">')
      this.portHeight = '80vh'
    }
    else{
      this.portHeight = '100vh'
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      let top = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
      // console.log(top)
      // this.clientTop = top
      document.querySelector('.header').setAttribute('style', 'top:'+top+'px')
      this.$nextTick()
    })
  },
  methods: {
    // 切换菜单
    handleLinkTo (name, tab) {
      if (name === 'toPlatform') {
        this.openUrl('https://cloud.yueq.com.cn/home')
        return 0
      }
      this.isHome = name === 'main_home'
      if (parseInt(this.produceList.indexOf(name)) === -1) {
        this.selectedNav = name
      } else {
        this.selectedNav = 'business'
      }
      if(name === 'projectList_detail') this.selectedNav = 'projectList'
      // if(name === 'participants' || name ==='innovation') this.selectedNav = 'innovation'
      // console.log(name)
      if (tab) {
        this.$router.push({
          name: `${name}`,
          params: {
            scroll: tab
          }
        })
      } else {
        this.$router.push({
          name: `${name}`
        })
      }
    },
    // 底部跳转
    footLinkTo (name, type) {
      this.isHome = name === 'main_home'
      this.selectedNav = name
      if (type) {
        this.$router.push({
          name: `${name}`,
          query: {
            type: type
          }
        })
      } else {
        this.$router.push({
          name: `${name}`
        })
      }
    },
    // 外部链接
    openUrl (url) {
      window.open(url, '_blank')
    },
    handleSelected (name) {
      switch (name) {
        case 'userInfo':
          this.handleLinkTo('user_information')
          break
        case 'changePwd':
          this.handleLinkTo('modify_password')
          break
        case 'logOut':
          this.signOutModal = true
          break
      }
    },
    // 业务介绍
    handleSelectedProduce (name) {
      switch (name) {
        case 'struct_analyse':
          this.handleLinkTo('struct_analyse')
          break
        case 'struct_moni':
          this.handleLinkTo('struct_moni')
          break
        case 'struct_tech':
          this.handleLinkTo('struct_tech')
          break
        // case 'struct_dev':
        //   this.handleLinkTo('struct_dev')
        //   break
      }
    },
    controlAutoplay(status){
      this.autoplay = status
    },
    setPortHeight() {
      if(this.isMobile) {
        this.portHeight = '80vh'
      }
      else{
        this.portHeight = '100vh'
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home {
  min-height: 100%;
  // width: 100%;
  min-width: 1400px;
  position: relative;
  // display: flex;
  // flex-direction: column;
  .home-top {
    .carousel {
      .item1 {
        width: 100%;
        background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/carousel1.png")
          center center no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        // padding-left: 160px;
        color: #fff;
        position:relative;
        &__title {
          position: relative;
          font-size: 36px;
          line-height: 2em;
          font-weight: 400;
          display: block;
          width: 650px;
        }
        &__title::after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 80px;
          height: 8px;
          background-color: #FAAD14;
        }
        &__title2 {
          position: relative;
          font-size: 36px;
          line-height: 2em;
          font-weight: 400;
          display: block;
          width: 650px;
          margin: 60px 0;
          text-align: right;
        }
        &__title2::after {
          content: "";
          position: absolute;
          bottom: -8px;
          right: 0;
          width: 80px;
          height: 8px;
          background-color: #FAAD14;
        }
        &__des {
          width: 670px;
          font-size: 14px;
          line-height: 2em;
          display: block;
          width: 650px;
        }
        .item1_sub {
          margin: 10px 0;
          font-size: 16px;
          line-height: 1.1em;
          display: block;
          width: 100%;
        }
      }
      .item2 {
        width: 100%;
        background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/carousel2.png")
          center center no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        &__title {
          font-size: 30px;
          line-height: 1.5em;
          font-weight: 400;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          letter-spacing: 3px;
        }
        &__des {
          font-size: 24px;
          line-height: 1.5em;
        }
        &__des span {
          color: #FAAD14;
        }
      }
      .item3 {
        width: 100%;
        background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/carousel3.png")
          center center no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        &__title {
          font-size: 48px;
          line-height: 1.5em;
          font-weight: 400;
          margin-bottom: 48px;
        }
        &__des {
          font-size: 16px;
          line-height: 1.5em;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          letter-spacing: 3px;
        }
      }
    }
  }
  .header--home {
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
  }
  .header {
    position: absolute;
    z-index: 99;
    width: 100%;
    min-width: 1400px;
    height: 128px;
    color: #fff;
    // padding: 0 56px;
    display: flex;
    justify-content: space-between;
    &__logo {
      display: flex;
      align-items: center;
      position: relative;
      // height: 56px;
      img{
        // width: 40%;
        width: 180px;
      }
      div {
        margin-left: -40px;
        span:first-of-type {
          display: block;
          width: 100%;
          text-align: center;
          font-size: 20px;
          line-height: 1.5em;
          letter-spacing: 10px;
          white-space: nowrap;
          padding-left: 8px;
        }
        span:last-of-type{
          display: block;
          width: 100%;
          text-align: center;
          font-size: 12px;
          white-space: nowrap;
        }
      }
    }
    &__nav {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      line-height: 1.5em;
      font-weight: 400;
      color: #818181;
      margin-top: 45px;
      // text-shadow: 5px 5px 5px #212124;
      .items {
        cursor: pointer;
        padding: 0 16px;
        margin: 0 5px;
      }
      .items:hover{
        color: #FFF;
      }
      /deep/.ivu-icon {
        font-size: 28px;
        line-height: 1em;
        // vertical-align: -1em;
      }
      .selected {
        color: #fff;
      }
      a {
        color: #818181;
      }
      .headImg {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-left: 8px;
      }
    }
  }
  .header--other {
    background-color: #212124;
  }
  .content {
    flex: 1;
    padding-top: 128px;
  }
  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    background-color: #2e2e30;
    &__nav {
      width: 70%;
      padding: 48px;
      display: flex;
      justify-content: space-evenly;
      .title {
        margin-bottom: 16px;
        font-size: 16px;
        line-height: 1.5em;
        font-weight: bold;
      }
      .items {
        font-size: 12px;
        line-height: 2.5em;
        cursor: pointer;
      }
      .image-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        .image {
          width: 144px;
          height: 144px;
          padding: 10px;
          background-color: #fff;
          border-radius: 32px;
          margin-bottom: 16px;
        }
      }
    }
    &__des {
      width: 100%;
      height: 88px;
      background-color: #212124;
      padding-top: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      line-height: 1.5em;
      pre {
        margin: 0;
        display: flex;
        justify-content: center;
        flex-direction: row;
      }
    }
  }
}
.beian{
  cursor: pointer;
  margin: 0 10px;
}
.beian:hover{
  text-decoration: underline;
  color: blue;
}
</style>
